import React from "react";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="w-full relative overflow-hidden bg-white min-h-[85vh] sm:min-h-[80vh] flex items-center">
      {/* Soft gradient background wash — kept to the left so it doesn't sit behind the video */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          className="absolute top-0 left-0 w-[55%] h-full"
          style={{
            background:
              "radial-gradient(ellipse 70% 70% at 25% 45%, rgba(75,80,233,0.07) 0%, rgba(75,80,233,0.02) 45%, transparent 70%)",
          }}
        />
      </div>

      {/* Content grid */}
      <div className="relative z-10 w-full max-w-[1300px] mx-auto px-5 md:px-10 py-16 sm:py-20 grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-4 items-center">
        {/* Left — text content */}
        <div className="flex flex-col gap-5 sm:gap-6">
          <h1 className="text-[40px] sm:text-[52px] md:text-[60px] text-blue-1 font-bold leading-[1.05] tracking-[-0.02em]">
            Blockchain on
            <br />
            Autopilot
          </h1>

          <p className="text-[15px] sm:text-[17px] text-gray-1 leading-[26px] max-w-[420px] font-medium">
            Meet Helix AI — one agent that deploys contracts, swaps tokens,
            transfers assets, and manages your portfolio on Ethereum.
            Just say what you need.
          </p>

          <div className="flex items-center gap-3 pt-2">
            <a
              href="https://ai.helix.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[14px] font-semibold text-white h-[50px] rounded-[14px] bg-blue-1 px-7
                         transition-all duration-200 ease-in-out
                         shadow-md hover:shadow-lg
                         transform hover:scale-105 active:scale-95
                         flex items-center justify-center gap-3"
            >
              Activate AI
              <svg
                className="w-4 h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                />
              </svg>
            </a>
            <Link
              to="/docs"
              className="text-[14px] font-semibold text-blue-1 h-[50px] rounded-[14px] border border-gray-2 px-7
                         transition-all duration-200 ease-in-out
                         hover:border-blue-2/30 hover:bg-blue-2/5
                         transform hover:scale-105 active:scale-95
                         flex items-center justify-center"
            >
              Explore Docs
            </Link>
          </div>
        </div>

        {/* Right — banner video */}
        <div className="flex items-center justify-center lg:justify-end">
          <video
            className="w-[100%] sm:w-[100%] lg:w-[100%] max-w-[960px] h-auto object-contain mix-blend-multiply"
            autoPlay
            muted
            playsInline
            preload="auto"
          >
            <source src="/assets/helix-banner.mp4" type="video/mp4" />
            <source src="/assets/helix-banner.webm" type="video/webm" />
          </video>
        </div>
      </div>
    </div>
  );
};

export default Hero;
